export const API = Symbol("API");
export const API_START = Symbol("API_START");
export const API_END = Symbol("API_END");
export const ACCESS_DENIED = Symbol("ACCESS_DENIED");
export const API_ERROR = Symbol("API_ERROR");